import {
    BUSINESS_PARTNER_FIELD_SEPARATOR,
    BUSINESS_PARTNER_REGEX,
    BUSINESS_PARTNER_SEPARATOR
} from "../constants/BUSINESS_PARTNERS";
import { IBPOKCheck, IBusinessPartner } from "../views/components/BusinessPartnersTextField/BusinessPartnersTextField";

const isBPOK = (bp: string): boolean => {
    const ret = bp?.match(BUSINESS_PARTNER_REGEX) !== null;
    return ret;
};

export const isContentOK = (text: string): IBPOKCheck => {
    const businessPartnersLines = text?.split(BUSINESS_PARTNER_SEPARATOR)?.map(i => i.trim());
    const areAllBPsOK = businessPartnersLines?.every(bp => isBPOK(bp));

    const businessPartners: IBusinessPartner[] = businessPartnersLines.map(line => {
        const fields = line.split(BUSINESS_PARTNER_FIELD_SEPARATOR);
        return {
            bpId: parseInt(fields[0]),
            bpName: fields[1],
            countryCode: fields[2]
        };
    });

    const result = areAllBPsOK;
    const ret: IBPOKCheck = {
        result,
        ...(result && {
            businessPartners: businessPartners
        }),
        error: !areAllBPsOK ? "INCORRECT_FORMAT" : null
    };

    return ret;
};
